import { render, staticRenderFns } from "./SectionDescription.vue?vue&type=template&id=68f39763&scoped=true&"
import script from "./SectionDescription.vue?vue&type=script&lang=ts&"
export * from "./SectionDescription.vue?vue&type=script&lang=ts&"
import style0 from "./SectionDescription.vue?vue&type=style&index=0&id=68f39763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f39763",
  null
  
)

export default component.exports